import React from "react";
import styled from 'styled-components';
import { FormattedHTMLMessage } from 'react-intl';

export default class KorrekturSchallpegel extends React.Component {
    render() {
        return(
<Wrapper>  
    <OneRow>

            <FormattedHTMLMessage id="KorrekturSchallpegel_TextBlock_1" />
            <FormattedHTMLMessage id="KorrekturSchallpegel_TextBlock_2" />
    

            <ImageModal src={require('../../../assets/img/schallpegelinfo_' + document.getElementById('root').dataset.locale + '.jpg')} alt="" title="">
            </ImageModal>
    <FormattedHTMLMessage id="KorrekturSchallpegel_TextBlock_3" />
    <FormattedHTMLMessage id="KorrekturSchallpegel_TextBlock_4" />
    </OneRow>
</Wrapper>
);
    }
}
const Wrapper = styled.div`
font-family:GROTESK Regular;
font-size:15px;
line-height:20px;
font-weight:100;
`;

const OneRow = styled.div`
clear:left;
`;

const ImageModal= styled.img`
max-width: 100%;

display: block;

`;